<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa, Renavam ou CNPJ"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-4">
          <label>Serviço</label>
          <Select2 :options="filterServiceNames" v-model="query.scrapingServiceName"/>
        </div>

        <div class="col-md-4">
          <label for="consult-status">Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label>Apps</label>
          <Select2 :options="filterAppName" v-model="query.appName"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="consult-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="consult-day" class="form-control">
        </div>
        
        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          class="btn btn-primary mt-1 mr-1"
          @click="reprocess"
          :disabled="disabledReprocess"
        >
          Reprocessar consultas
        </button>

        <button
          class="btn btn-primary mt-1 mr-1"
          @click="createReport"
          :disabled="disabledReprocess"
        >
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>

            <button
              class="btn btn-outline ml-3 mb-1"
              v-if="consults.length > 0"
              @click="changeCheckAll"
              :class="{ 'btn-outline-active': checkAll}"
            >
              {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
            </button>

            <div class="float-right" style="display: inline-flex;align-items: center;">
              <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
              <select v-model="order" @change="find()" class="browser-default custom-select">
                <option :value="['updated_at', 'desc']">Data de atualização</option>
                <option :value="['created_at', 'desc']">Data de criação</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>

      <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow"/>
              </th>
              <th>ID</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>CNPJ</th>
              <th>Status</th>
              <th>Serviço</th>
              <th>Consultado por</th>
              <th>Conta</th>
              <th>Erros</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="consult in consults" :key="consult.id">
              <td :class="buildClass(consult)">
                <BkpsCheckBox v-model="consult.checked"/>
              </td>
              <td>{{ consult.id }}</td>
              <td>{{ consult.plate }}</td>
              <td>{{ consult.renavam }}</td>
              <td>{{ consult.cnpj | cnpj }}</td>
              <td>{{ consult.status | t }}</td>
              <td>{{ consult.scrapingServiceName }}</td>
              <td>{{ consult.createdBy }}</td>
              <td>{{ getAccountName(consult) }}</td>
              <td v-if="consult.errorMessages && consult.errorMessages.length > 0">
                <small v-for="(errorMessage, index) in showErrors(consult)" :key="index">
                  <span class="truncate-1">
                    {{index + 1}} - {{ errorMessage }}
                  </span>
                  <br>
                </small>
              </td>
              <td v-else>-</td>
              <td>{{ consult.createdAt | datetime }}</td>
              <td>{{ consult.updatedAt | datetime }}</td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-outline" @click="showConsultData(consult)">
                    Ver
                  </button>
                  <router-link :to="`/admin/maestro/consults/${consult.id}`" class="btn btn-outline">
                      Detalhes
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="changePagination"
            />
          </div>
        </div>
      
      </div>
    </div>

    <!-- Modal for showing consult data -->
    <ShowDataModal
      v-model="showModal"
      :data="currentConsult"
      header="Dados da Consulta"
      :deep="3"
    />

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import ShowDataModal from '@/components/admin/ShowDataModal'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import CheckedModels from '@/mixins/CheckedModels'

  import EntityProxy from '@/models/EntityProxy'
  import handleSearchable from '@/models/handleSearchable'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'

  import Select2 from '@/components/shares/Select2'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  const reprocess = (consults, instance) => {
    let delay = 0
    consults = consults.filter(c => c.checked)

    instance.openLoad()
    consults.forEach(consult => {
      setTimeout(() => reprocessConsult(consult, instance), delay)
      delay += 500
    })

    setTimeout(() => {
      instance.closeLoad()
      instance.asyncTemplateSelect({
        pagination: true
      })
    }, delay)
  }

  const reprocessConsult = (consult, instance) => {
    instance.axios.put(`admin/maestro/consults/${consult.id}/reprocess`)
      .then(() => instance.$notify.add('Consulta reprocessada'))
      .catch(e => {
        const msg = (e && e.errors) || e
        instance.$notify.addError(`Consulta ${consult.id}: ${msg}`)
      })
  }

  const batchReprocess = (query, instance) => {
    instance.openLoad()
    instance.axios.post('admin/maestro/consults/batch_reprocess', query)
      .then(() => instance.$notify.add('Consultas agendadas'))
      .catch(e => instance.$notify.addError(e))
      .finally(() => {
        instance.checkAll = false
        instance.checkAllRow = false
        instance.consults.forEach(c => c.checked = false)
        instance.closeLoad()
      })
  }

  export default {
    components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, Pagination, SearchIcon, Select2, ShowDataModal },
    computed: {
      badgeFilters() {
        return [
          this.filterAccount, this.filterEndDate, this.filterStatus,
          this.filterStartDate, this.filterServiceNames, this.filterAppName
        ]
      },
      consults() {
        return this.getModels || []
      },
      disabledReprocess() {
        return !this.consults.some(c => c.checked)
      }
    },
    created() {
      this.addOrderBy('updatedAt')
      this.$set(this.query, 'periodType', 'created_at')
      
      const date = new Date()
      date.setDate(date.getDate())
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.fetchScrapingServices()
      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    },
    data: () => ({
      accounts: [],
      currentConsult: {},
      filterAccount: null,
      filterServiceNames: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status',
        table: [
          ['Processado', 'processed'],
          ['Em processo', 'processing'],
          ['Com erro', 'error'],
          ['Erro do usuário', 'processed_with_user_error']
        ]
      }),
      filterAppName: new Filter({
        key: 'appName',
        label: 'Apps',
        table: [
          ['Df-e', 'df-e'],
          ['Cm Frotas', 'cm-frotas'],
          ['Cm Taxas', 'cm-taxas'],
          ['Cm Embarcador', 'cm-embarcador'],
          ['Cm Cronotacografo', 'cm-crono'],
        ]
      }),
      nameModel: 'Consult',
      showModal: false,
    }),
    inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
    methods: {
      buildClass(consult) {
        const types = {
          processed: 'marker-green',
          processing: 'marker-yellow'
        }

        return types[consult.status] || 'marker-red'
      },
      buildPath() {
        return 'admin/maestro/consults'
      },
      changeCheckAll() {
        this.changeCheck({ checkAll: !this.checkAll, sources: this.consults })
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.consults })
      },
      changeCheckRow(){
        this.changeCheck({ sources: this.consults })
      },
      changePagination(page) {
        this.checkAll = false
        this.checkAllRow = false
        this.pagination(page)
      },
      find() {
        this.asyncTemplateSelect()
      },
      buildFilterServiceNames(services) {
        this.filterServiceNames = new Filter({
          key: 'scrapingServiceName',
          label: 'Serviço',
          table: services.map(s => [
            `${s.friendlyName} (${s.appName}) (${s.enable ? 'Ativo' : 'Inativo'})`,
            `${s.name},${s.appName}`
          ])
        })
      },
      fetchScrapingServices() {
        const key = 'scrapingServiceToAdmin'
        const data = this.$ls.get(key)

        if (data) {
          this.buildFilterServiceNames(EntityProxy.build(data))
          return
        }

        const params = {
          meta: false,
          per_page: 10000,
        }

        return this.axios.get('maestro/scraping_services', { params })
          .then(response => EntityProxy.build(response.data))
          .then(services => {
            this.$ls.set(key, services, { minutes: 5 })
            this.buildFilterServiceNames(services)
          })
          .catch(e => this.$notify.addError(e))
      },
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        const params = ModelMapper.methods.buildParams.call(this, pagination);

        if (params.q?.scraping_service_name) {
          let serviceValues = params.q.scraping_service_name;

          if (!Array.isArray(serviceValues)) {
            serviceValues = [serviceValues];
          }

          if (serviceValues.length === 0) {
            delete params.q.scraping_service_name;
            return params;
          }

          const serviceNames = [];
          const appNames = [];

          serviceValues.forEach(serviceValue => {
            if (serviceValue?.includes?.(',')) {
              const [name, appName] = serviceValue.split(',');
              serviceNames.push(name);
              appNames.push(appName);
            } else {
              serviceNames.push(serviceValue);
            }
          });

          if (serviceNames.length === 1) {
            params.q.scraping_service_name = serviceNames[0];
            if (appNames.length === 1 && !params.q.app_name) {
              params.q.app_name = appNames[0];
            }
          } else {
            params.q.scraping_service_name = serviceNames;
            if (appNames.length > 0 && !params.q.app_name) {
              params.q.app_name = appNames;
            }
          }
        }

        return params;
      },
      reprocess() {
        const amount = this.checkAll ? this.meta.totalCount : this.consults.filter(c => c.checked).length
        if (!confirm(`Reprocessar ${amount} Consulta(s).\nTem certeza?`))
          return

        if (this.checkAll && this.meta.totalCount > 10)
          batchReprocess(this.buildParams(), this)
        else
          reprocess(this.checkAll ? this.consults.map(c => ({...c, checked: true})) : this.consults, this)
      },
      createReport() {
        let params
        let amount

        if (this.checkAll) {
          params = this.buildParams()
          amount = this.meta.totalCount
        } else {
          const ids = this.consults.filter(c => c.checked).map(c => c.id)
          params = { q: { id: ids } }
          amount = ids.length
        }

        if (!confirm(`Exportar ${amount} Consulta(s).\nTem certeza?`))
          return

        this.openGlobalLoad()
        this.axios.get('admin/maestro/consults/report', {params})
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
              else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      showConsultData(consult) {
        this.currentConsult = consult
        this.showModal = true
      },
      showErrors(consult) {
        const errors = new Set(consult.errorMessages.map(e => e.message || e.detail || e))
        return errors
      }
    },
    mixins: [CheckedModels, ModelMapper],
    name: 'Index',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      }
    }
  }
</script>

<style scoped>
  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>
